import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import tourConsentsApi from '@/features/dashboard/tourConsents/api/tourConsentsApi.ts';
import { tourConsentsApiQueryKeys } from '@/features/dashboard/tourConsents/api/tourConsentsApi.queryKeys.ts';
import { TourConsentDto } from '@/features/dashboard/tourConsents/types/TourConsentDto.ts';

export default function useGetTourConsents(tourId: string | undefined) {
  return useQuery(getTourConsentsQueryOptions(tourId));
}

export const getTourConsentsQueryOptions = (
  tourId: string | undefined,
): UseQueryOptions<TourConsentDto[]> => ({
  queryKey: tourConsentsApiQueryKeys.byTourId(tourId ?? ''),
  queryFn: () => tourConsentsApi.getAll(tourId!),
  enabled: !!tourId,
});
